import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateGame from '@/modules/game/api/hooks/useMutationUpdateGame'
import { GetGameListTableData } from '@/modules/game/type'
import { useQueryClient } from '@tanstack/react-query'
import { GameQueryKeys } from '@/modules/game/keys'

interface SwitchToOppositeProps {
	row: GetGameListTableData
}

export function SwitchToOpposite({ row }: SwitchToOppositeProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateGame } = useMutationUpdateGame()

	const handleMutate = async (value: boolean) => {
		await updateGame({
			id: row.id,
			payload: {
				switchToOpposite: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [GameQueryKeys.GetGameList],
		})
	}

	return (
		<SetIsActive
			defaultChecked={row.switchToOpposite || false}
			onMutate={handleMutate}
			successMessage="อัพเดทการสลับเวอร์ชั่นสำเร็จ"
		/>
	)
}
